module.exports = __webpack_public_path__ + "static/media/royallakeside.d82cb407.png";